import styled, { css } from 'styled-components'
import SilhouetteImg from '@app/assets/images/banner-silhouette-light.png'

const Main = styled.main`
  background-color: #f5f5f5;
`

const Page = styled.article`
  ${({ theme }) => css`
    max-width: 120rem;
    margin: 0 auto;
    // padding: ${theme.spacing(10)};
    h4 {
      text-align: center;
    }
    ol > div {
      background-color: red;
    }
  `}
`

const Hero = styled.section`
  ${({ theme }) => css`
    width: 100%;
    padding: ${theme.spacing(5)} ${theme.spacing(10)};
    background: rgb(226, 226, 226);
    background: linear-gradient(0deg, rgba(226, 226, 226, 1) 23%, rgba(245, 245, 245, 1) 27%);
    color: white;
    text-align: center;

    h1 {
      color: black;
    }
  `}
`
const HeroIcon = styled.div`
  ${() => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 8rem;
    height: 8rem;
    border-radius: 4rem;
    background-color: #89b641;

    > svg {
      color: white;
    }
  `}
`
const Steps = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(2)};
  `}
`

const Step = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(3)} ${theme.spacing(3)};
    margin: 0 ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)};
    background-color: white;
    border: 1px solid #ebebeb;
    display: flex;
    flex-direction: row;
  `}
`
const StepContent = styled.div`
  ${({ theme }) => css`
    padding: 0 ${theme.spacing(2)};

    h4 {
      margin: 0;
      text-align: left;
    }

    p {
      text-align: left;
    }
  `}
`

const Circle = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 10px;
    width: 32px;
    height: 32px;
    min-width: 32px;
    border: 1px solid #000000;
    border-radius: 50px;

    span {
      flex: none;
      order: 0;
      flex-grow: 0;
    }
  `}
`

const Payee = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(2)};
    background-color: ${theme.palette.grey[100]};
  `}
`

const ImgLeft = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.palette.grey[100]};
  `}
`
const ImgRight = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.palette.grey[200]};
  `}
`

const Banner = styled.section`
  ${({ theme }) => css`
    padding: ${theme.spacing(5)};
    text-align: center;
    background-color: #4c2f82;
    background-image: ${`url(${SilhouetteImg})`};
    background-repeat: no-repeat;
    background-position: 13% 50%;
    background-size: 320px;

    ${theme.maxMedia('md')} {
      background-image: none;
    }

    h2 {
      color: white;
    }

    button {
      background-color: ${theme.palette.grey[100]};
    }
  `}
`

export default {
  Main,
  Page,
  Hero,
  HeroIcon,
  Payee,
  Banner,
  Steps,
  Step,
  ImgLeft,
  ImgRight,
  StepContent,
  Circle,
}
